<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="data-list-container">
        <edit-address-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
        <vs-card card-background="red" v-for="(item,index) in list" :key="index">
            <div class="flex items-center flex-wrap">
                <div class="p-4 flex-1">
                    <div>
                        <span>{{item.province}} , {{item.city}}</span>
                    </div>
                    <h3>
                        {{item.address}}
                    </h3>
                </div>
                <vs-button v-if="!item.default_address" type="border" @click="setDefault(item)" class="ltr:mr-2 rtl:ml-2">
                    Set as default address
                </vs-button>
                <vs-button @click="editData(item)" class="ml-2">Edit Address</vs-button>
            </div>
        </vs-card>
        <div class="flex items-center justify-center">
            <vs-button size="large" color="primary" @click="addNewData" type="border" class="flex items-center justify-center">
                <feather-icon icon="PlusIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
                <span>Add New Address</span>
            </vs-button>
        </div>
    </div>
</template>

<script>
    import EditAddressSidebar from "./comp/EditAddressSidebar";

    export default {
        components: {
            EditAddressSidebar
        },
        data() {
            return {
                selected: [],
                // products: [],
                itemsPerPage: 4,
                isDefault: false,

                // Data Sidebar
                addNewDataSidebar: false,
                sidebarData: {},
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            list() {
                return this.$store.state.address.list;
            }
        },
        methods: {
            addNewData() {
                this.sidebarData = {new:Math.random()};
                this.toggleDataSidebar(true)
            },
            setDefault(item){
                this.$store.dispatch("address/setDefault" , item).then(()=>{
                    this.$store.dispatch("address/fetch")
                });
            },
            deleteData(id) {
                this.$store.dispatch("dataList/removeItem", id).catch(err => {
                    console.error(err)
                })
            },
            editData(data) {
                // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
                this.sidebarData = data
                this.toggleDataSidebar(true)
            },
            getOrderStatusColor(status) {
                if (status == 'on_hold') return "warning"
                if (status == 'delivered') return "success"
                if (status == 'canceled') return "danger"
                return "primary"
            },
            getPopularityColor(num) {
                if (num > 90) return "success"
                if (num > 70) return "primary"
                if (num >= 50) return "warning"
                if (num < 50) return "danger"
                return "primary"
            },
            toggleDataSidebar(val = false) {
                this.addNewDataSidebar = val
            }
        },
        created() {
            this.$store.dispatch("address/fetch")
        },
        mounted() {
            this.isMounted = true;
        }
    }
</script>
